import { Suspense } from 'react';
import { Await, useLoaderData, useNavigate } from 'react-router-dom';
import Text from '../../atoms/Text';
import Token from './Token';
import TokenMobile from './mobile/Token';
import { PanelMobile } from '../MainPage/mobile';
import Header from '../MainPage/Header';
import useDevice from '../MainPage/useMobileDetect';
import { tokenPageLoaderDataType } from '../loaders/tokenPageLoader';
import TickersDisplayBar from '../../components/TickersDisplayBar';
import Modal from '../../components/Modal';
import TokenPagePlaceholder from './Placeholder';
import TokenPageMobilePlaceholder from './mobile/Placeholder';
import Notifs from '../../components/Notifications';

const TokenPage = () => {
  const navigate = useNavigate();
  const { token, trendingCoins } = useLoaderData() as Record<string, any>;
  const { isMobile } = useDevice();

  const renderContent = () => (
    <Suspense
      fallback={
        isMobile ? <TokenPageMobilePlaceholder /> : <TokenPagePlaceholder />
      }
    >
      <Await resolve={trendingCoins} errorElement={<div>Error Loading</div>}>
        {(trendingCoins: tokenPageLoaderDataType) => {
          if (!token) {
            if (isMobile) {
              return (
                <div className='centrify' style={{ height: 300 }}>
                  <Text size={20} className='text--grey-200'>
                    No data...
                  </Text>
                </div>
              );
            }

            return (
              <div className='centrify' style={{ height: 600 }}>
                <Text size={24} className='text--grey-200'>
                  No data...
                </Text>
              </div>
            );
          }

          if (isMobile) {
            return <TokenMobile token={token} trendingCoins={trendingCoins} />;
          }

          return <Token token={token} trendingCoins={trendingCoins} />;
        }}
      </Await>
    </Suspense>
  );

  if (isMobile) {
    return (
      <PanelMobile title={`${token.title} token`} onBack={() => navigate(-1)}>
        <div className='mobile_seo_page'>
          {renderContent()}
          <Modal />
          <Notifs />
        </div>
      </PanelMobile>
    );
  }

  return (
    <div className='seo_page'>
      <TickersDisplayBar />
      <Header chartPicker={false} />
      {renderContent()}
      <Modal />
      <Notifs />
    </div>
  );
};

export default TokenPage;
